module.exports = __webpack_public_path__ + "img/rowrite.95b9985e.png";